export default "__VITE_ASSET__DUD6fFMJ__"